import { useFeatureFlag } from '@moda/portal-stanchions';
import { isNavLinksFlagValue, NavLinksFlagValue } from '../../lib/isNavLinksFlagValue';

export const useHomePageJumpLinks = () =>
  useFeatureFlag<NavLinksFlagValue>('homepage-mobile-jump-links', [
    { default: null },
    { getFromTreatment: treatment => (isNavLinksFlagValue(treatment) ? treatment : null) }
  ]);
